module.exports = __webpack_public_path__ + "img/coming-soon.95ce6e15.jpg";